<template>
    <div class="projectBody">
        <div class="width_total_100 headerBg projectTopBg animateContent projectAnimate1">
            <div class="w_container">
                <div class="commonTop">
                    <OmpLink></OmpLink>
                </div>
                <div class="bannerPart">
                    <div>
                        <div>赋予企业数据洞察力</div>
                        <p>引领商业变革风暴</p>
                    </div>
                    <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                </div>
                <div class="instruction">
                    <div class="instruTitle">
                        <div>场景分析</div>
                        <p>Scene analysis</p>
                    </div>
                    <div class="sceneAnalysis">
                        <ul>
                            <li>
                                <div class="scenePer">
                                    <img src="@/assets/img/project_person1.png" />
                                    <i>中层</i>
                                    <div>工作汇报</div>
                                    <p>快速准确获取数据报表，直接呈现问题根源，指导改进方向</p>
                                </div>
                            </li>
                            <li class="sceneSpecial">
                                <div class="scenePer">
                                    <img src="@/assets/img/project_person2.png" />
                                    <i>老板</i>
                                    <div>企业监控</div>
                                    <p>一键查看关键营运数据，企业状况一手掌握，快速下达商业决策</p>
                                </div>
                            </li>
                            <li>
                                <div class="scenePer">
                                    <img src="@/assets/img/project_person3.png" />
                                    <i>职员</i>
                                    <div>问题反馈</div>
                                    <p>全面收集、分析、汇总各类数据报表。及时发现异常状况，向上反馈</p>
                                </div>
                            </li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 proBottomBg">
            <div class="w_container">
                <!--职能分析-->
                <div class="sceneFunAnalys" style="margin-top: 5px;">
                    <div class="instruTitle proMakeTitle">
                        <div>职能分析</div>
                        <p>Function analysis</p>
                    </div>
                    <div class="sceneCon">
                        <el-tabs type="border-card">
                            <el-tab-pane label="财务">
                                <div class="sceneTabCon">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>场景</div>
                                            <p>临近月底，天天加班做报表，品类品号一个个对，几十张图表汇总分析，真头大！</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛点</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;做报告耗时长。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;核对工作量大。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-CN/img/scene_01.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解决方案</div>
                                            <ul>
                                                <li>多维度报表分析，按条件筛选查看</li>
                                                <li>多期间数据比较，年增率快速产生</li>
                                                <li>跨报表关联功能，多报表随意整合</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="业务">
                                <div class="sceneTabCon">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>场景</div>
                                            <p>这个季度A产品的销售额离目标值还差几十万的缺口，看来今晚我得约大客户李总吃个饭了....</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛点</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;销售目标是否达成，难以定性。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;难以多维度整理、查看报表。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-CN/img/scene_02.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解决方案</div>
                                            <ul>
                                                <li>多数据来源上传，归纳汇整数据不乱</li>
                                                <li>直连ERP报表，按期筛选查看明细</li>
                                                <li>设定当前目标值，制定对策冲业绩</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="生管">
                                <div class="sceneTabCon sceneSG">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>场景</div>
                                            <p>糟糕，今天客户有急单，但IT那边还没给我统计出到底还缺哪些原料，哎，总是停工待料，怎么办....</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛点</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;原材料经常出现短缺情况，导致开工难。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;原材料已领、未领情况不明确。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-CN/img/scene_03.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解决方案</div>
                                            <ul>
                                                <li>人人都能做好图表，简单拖曳即可完成</li>
                                                <li>数据自动上传更新，原料状况全程控管</li>
                                                <li>随时随地查阅数据，工单开工准时准点</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="采购">
                                <div class="sceneTabCon">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>场景</div>
                                            <p>生产计划一旦排定，就要给几十个供应商打电话，真不知该从哪家先着手！</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛点</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;采购货品需经常对账，费时费力。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;难以知晓采购货品是否已入库。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-CN/img/scene_04.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解决方案</div>
                                            <ul>
                                                <li>直连ERP报表，货品明细好查询</li>
                                                <li>适时预警常提醒，货品采购不遗忘</li>
                                                <li>已购未进催厂商，免去对帐抢时效</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="IT人员">
                                <div class="sceneTabCon">
                                    <div class="sceneTabCon_top clearfix">
                                        <div class="sceneTabConTop_left">
                                            <div>场景</div>
                                            <p>每天都要花费大量时间帮不同部门做报表，难道资讯部门就没有更大的价值了吗？</p>
                                        </div>
                                        <div class="sceneTabConTop_right">
                                            <div>痛点</div>
                                            <ul>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;耗费大量时间帮其他部门重复做图表。</li>
                                                <li><img src="../assets/img/scene_06.png" />&nbsp;&nbsp;需要手动更新系统数据，做无价值劳动。</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="sceneTabCon_next clearfix">
                                        <img src="https://escloud.digiwincloud.com/static/zh-CN/img/scene_05.png" />
                                        <div class="sceneTabConNext_right">
                                            <div>解决方案</div>
                                            <ul>
                                                <li>设置图表可保存，下次还能接着用</li>
                                                <li>系统内置模板库，信息省事不加班</li>
                                                <li>自动更新数据源，资料维护不断链</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
                <!--场景视频-->
                <!-- <div class="sceneVideo">
                    <div class="instruTitle proMakeTitle">
                        <div>场景视频</div>
                        <p>Scene Video</p>
                    </div>
                    <div class="sceneVideoCon">
                       <ul>
                           <li v-for="(item, index) in videoArr">
                               <img :src="'static/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                <p class="sceneVideoTi">&nbsp;&nbsp;&nbsp;{{item.title}}
                                    <a class="playBtn" @click="toPlaying(item.id, item.title)"></a>
                                </p>
                           </li>
                       </ul>
                    </div>
                </div> -->
                <Footer></Footer>
            </div>
        </div>
        <Control></Control>
        <FreeTry :visible.sync="freeTryVisible"></FreeTry>
        <!-- 模态框（Modal） -->
        <!-- <div class="modal fade" :id="'myModal'" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div style="width:70%; margin:0 auto;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">×</button>
                            <h4 class="modal-title" id="myModalLabel" style="font-weight:bold;">{{popVideoTitle}}</h4>
                        </div>
                        <video :src="'static/video/'+ popVideoId +'.mp4'" controls="controls" preload="auto" :poster="'static/img/'+ popVideoId +'.png'" id="popVideo" autoplay="autoplay" width="100%"></video>
                    </div>
                </div>
            </div>
        </div> -->

    </div>
</template>
<script>
    import "@/assets/css/w-style.css"

    import OmpLink from "@/components/common/OmpLink.vue"
    import Control from "@/components/common/Control.vue"
    import Footer from "@/components/common/Footer.vue"
    import FreeTryButton from "@/components/common/FreeTryButton.vue"
    import FreeTry from "@/components/common/FreeTry.vue"

  export default {
    components: {
        OmpLink,
        Control,
        Footer,
        FreeTryButton,
        FreeTry
    },
    name: 'Scene',
    data() {
      return {
        freeTryVisible: false,
        videoArr: [
            {id:'sceneVideo_01', title:'财务篇'},//sceneVideo_1
            {id:'sceneVideo_02', title:'业务篇'}//sceneVideo_2
        ],
        
        popVideoId:'',
        popVideoTitle:'',
      }
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Scene',
            contentName : '',
            extend2: 'CN',
        }, {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    mounted() {
        this.projectTopAnimate(); // 顶部动画
         $('#myModal').on('hide.bs.modal',//模态框关闭触发事件
            function() {
                document.getElementById('popVideo').currentTime=0
                document.getElementById('popVideo').pause();
            })
    },
    methods: {
        projectTopAnimate() {
            var projectAnimate_show1=1;
            $(".projectBody").children(".animateContent").each(function() {
            if($(this).hasClass("projectAnimate1") &&  parseInt(projectAnimate_show1)){
                projectAnimate_show1 = 0;
                $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                $(this).find(".sceneAnalysis li:nth-child(1)").delay(800).addClass('animated bounceInLeft');
                $(this).find(".sceneAnalysis li:nth-child(2)").delay(800).addClass('animated bounceInDown');
                $(this).find(".sceneAnalysis li:nth-child(3)").delay(800).addClass('animated bounceInRight');
            }
	     });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        },
         // @click 视频播放
        toPlaying(videoId,videoTitle){
            document.getElementById('popVideo').currentTime=0
            // document.getElementById('popVideo').play();
            this.popVideoId = videoId
            this.popVideoTitle = videoTitle
            $("#myModal").modal({});
        }
    }
  }
</script>
<style scoped>
.sceneVideoCon ul{
    display:flex;
    justify-content: space-between;
}
.sceneVideoCon ul li{
    width: calc(50% - 10px);
}
.sceneVideoCon ul li p{
    position: relative;
    background: #E6F7FF;
    height: 30px;
    line-height: 30px;
    text-align: left;
}
.sceneVideoCon ul li img{
    width: 100%;
}
.playBtn{
    position: absolute;
    top: 6px;
    right: 10px;
    width:0;
    height:0;
    border-top:8px solid transparent;
    border-bottom:8px solid transparent;
    border-left:12px solid #005D8C;
    cursor: pointer;
}
.playBtn:hover{
    opacity: 0.6;
}
.modal-dialog{
    width: 100%;
}
#myModal::-webkit-scrollbar{
    display:none;
}
</style>


// WEBPACK FOOTER //
// src/components/Scene.vue